'use client'

import { memo } from 'react'
import { Phone } from 'lucide-react'
import { BaseNode } from './BaseNode'

interface IncomingCallNodeProps {
  selected?: boolean
}

function IncomingCallNodeComponent({ selected }: IncomingCallNodeProps) {
  return (
    <BaseNode
      icon={<Phone className="w-4 h-4" />}
      label="Incoming Call"
      selected={selected}
      hasInputHandle={false}
      className="border-green-500/50 bg-green-50/50 dark:bg-green-950/20"
    >
      <p className="text-xs text-muted-foreground">
        Entry point for incoming calls
      </p>
    </BaseNode>
  )
}

export const IncomingCallNode = memo(IncomingCallNodeComponent)
